/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { InjectionToken } from '@angular/core'

export const WINDOW = new InjectionToken<WindowWrapper>('window object', {
  providedIn: 'root',
  factory: () => window,
})

export class WindowWrapper extends Window {}
